import React, { Component } from "react";
import { Table } from "reactstrap";
import { v4 as uuid } from "uuid";

export class ModuleRatingsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortedBy: null,
    };
  }

  listSorter = (key, order = "asc") => {
    return (a, b) => {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0;
      }
      const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
      const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA < varB) {
        comparison = 1;
      } else if (varA > varB) {
        comparison = -1;
      }
      this.setState({ sortedBy: key });
      return order === "desc" ? comparison * -1 : comparison;
    };
  };

  render() {
    var ratingsResponse = this.props.ratingsResponse;
    var avgRating = this.props.avgRating;
    var totRatings = this.props.totRatings;
    var mappedRatings = this.props.ratingsResponse.map((ratings) => {
      return (
        <tr style={{ cursor: "text" }} key={uuid()}>
          <td>{ratings.courseName}</td>
          <td>{ratings.moduleName}</td>
          <td>{ratings.gradeAverage}</td>
          <td>{ratings.numberOfGrades}</td>
        </tr>
      );
    });

    return (
      <div className="container-fluid admin-container">
        <Table>
          <thead>
            <tr>
              <th>Totalt genomsnittligt betyg: {avgRating}</th>
              <th>Totalt antal betyg: {totRatings}</th>
            </tr>
          </thead>
        </Table>
        <Table
          hover
          className="table table-striped clickable"
          id="grades-table"
        >
          <thead>
            <tr>
              <th
                onClick={() =>
                  ratingsResponse.sort(this.listSorter("courseName", "desc"))
                }
              >
                Kurs
              </th>
              <th
                onClick={() =>
                  ratingsResponse.sort(this.listSorter("moduleName", "desc"))
                }
              >
                Modul
              </th>
              <th
                onClick={() =>
                  ratingsResponse.sort(this.listSorter("gradeAverage"))
                }
              >
                Genomsnittligt betyg
              </th>
              <th
                onClick={() =>
                  ratingsResponse.sort(this.listSorter("numberOfGrades"))
                }
              >
                Antal betyg
              </th>
            </tr>
          </thead>
          <tbody>{mappedRatings}</tbody>
        </Table>
      </div>
    );
  }
}
export default ModuleRatingsTable;
